import { render, staticRenderFns } from "./px-responsive-bitmap.vue?vue&type=template&id=7065d1b8&"
import script from "./px-responsive-bitmap.vue?vue&type=script&lang=ts&"
export * from "./px-responsive-bitmap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports